import type { ReactNode } from 'react';

type Tone = 'neutral' | 'amber' | 'cyan' | 'violet' | 'red';

const TONES: Record<Tone, string> = {
  neutral: 'border-line2 text-mut',
  amber: 'border-amber/50 text-amber',
  cyan: 'border-cyan/50 text-cyan',
  violet: 'border-violet/50 text-violet',
  red: 'border-red/60 text-red',
};

export function Chip({ children, tone = 'neutral' }: { children: ReactNode; tone?: Tone }) {
  return (
    <span
      className={`inline-flex items-center rounded-[4px] border px-1.5 py-0.5 text-[10px] uppercase tracking-wider ${TONES[tone]}`}
    >
      {children}
    </span>
  );
}
